import { useCampaignStateAutoUpdate } from '../slices/campaigns';

const GlobalHooksComponent = () => {
  useCampaignStateAutoUpdate();
  return null;
};

export default GlobalHooksComponent;
